/**
 * Emit a custom event with the given name and value.
 * @param {string} event - The name of the custom event.
 * @param {any} value - The value to be associated with the event.
 * @param {object} [options] - Optional event options (bubbles, cancelable, etc.).
 */
export function emit(event, value, options = { bubbles: false, cancelable: false })
{
    if (!event) {
        console.error("Event name are required.");
        return;
    }

    try {
        const emit = new CustomEvent(event, { detail: value, ...options });
        document.dispatchEvent(emit);
    }catch (error){
        console.error("Error emitting custom event:", error);
    }
}

export function getObjectById(canvas, id)
{
    return canvas.getObjects().find((object) => object.id === id) || null;
}

export function getElementByKey(array, key)
{
    for (const obj of array)
    {
        if (obj.key === key) { return obj.value; }
    }
    return null;
}


export function asset(path) {
    if (path.startsWith('storage/')) {
        path = path.substring(8);
    }

    return `${STORAGE_URL}${path}`;
}

export function api(path) {
    return `${window.location.origin}/${path}`;
}



export function renderIcon(icon)
{
    return function renderIcon(ctx, left, top, styleOverride, fabricObject) {
        var size = this.cornerSize;
        ctx.save();
        ctx.translate(left, top);
        ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
        ctx.drawImage(icon, -size/2, -size/2, size, size);
        ctx.restore();
    }
}

export function formatMoney(amount, locale = 'pt-BR', currency = 'BRL')
{
    return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency
    }).format(amount);
}
